import { mapActions, mapGetters, mapState } from 'vuex';
import { IVendor } from '@/services/vendor';
import ChromeDashboard from '@/components/chrome/Dashboard.vue';
import ListBox from '@/components/list/ListBox.vue';
import { askDelete } from '../../common';

export default (storeName: string) => ({
  data: () => ({
    fetched: false,
  }),
  computed: {
    ...mapGetters(storeName, [
      'isSearchLoading',
    ]),
    ...mapState(storeName, [
      'list',
      'page',
    ]),
  },
  methods: {
    ...mapActions(storeName, ['load']),
    askDelete({ id, name }: IVendor) {
      askDelete
        .bind(this)(id, name);
    },
    fetchData() {
      // set initial search params
      const { page, search } = this.$route.query;
      const params: any = {};
      if (page) {
        params.number = Number(page);
      }
      if (search) {
        params.query = {
          name: {
            _ilike: `%${search}%`,
          },
        };
      }
      return this.load(params);
    },
  },
  components: {
    ChromeDashboard,
    ListBox,
  },
} as IView);
